import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  useTheme,
  Divider,
  IconButton
} from "@mui/material";
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DeleteDialog = ({
  isDeleteDialogOpen,
  setIsDeleteDialogOpen,
  handleDeleteConfirm,
  name,
}) => {
  const theme = useTheme();

  const handleDelete = async () => {
    try {
      await handleDeleteConfirm();
      toast.success("Agent supprimé avec succès");
      setIsDeleteDialogOpen(false);
    } catch (error) {
      const errorMessage = error.response?.data?.error || "Erreur lors de la suppression de l'agent";
      toast.error(errorMessage);
    }
  };

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      
      <Dialog
        open={isDeleteDialogOpen}
        onClose={() => setIsDeleteDialogOpen(false)}
        maxWidth="sm"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: 3,
            [theme.breakpoints.down('sm')]: {
              margin: 1
            }
          }
        }}
      >
        <DialogTitle 
          sx={{ 
            bgcolor: 'primary.main', // Utilisation de la couleur principale de la clinique
            color: 'primary.contrastText',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <Box display="flex" alignItems="center">
            <WarningAmberRoundedIcon sx={{ mr: 1.5, color: 'inherit' }} />
            <Typography variant="h6" component="div">
              Confirmation de suppression
            </Typography>
          </Box>
          <IconButton 
            onClick={() => setIsDeleteDialogOpen(false)}
            size="small"
            sx={{ color: 'inherit' }}
          >
            <CloseRoundedIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ p: 4 }}>
          <Box display="flex" alignItems="center" mb={2}>
            <WarningAmberRoundedIcon 
              sx={{ 
                fontSize: 40, 
                mr: 2,
                color: 'primary.main' // Harmonisation avec la couleur de la clinique
              }} 
            />
            <Typography variant="body1">
              Êtes-vous certain de vouloir supprimer définitivement <br />
              <Box component="span" fontWeight="bold" color="secondary.main">
                {name}
              </Box> ? 
            </Typography>
          </Box>

          <Typography 
            variant="body2" 
            color="text.secondary"
            sx={{ pl: 6 }}
          >
          </Typography>
        </DialogContent>

        <Divider sx={{ mx: 3 }} />

        <DialogActions sx={{ p: 3 }}>
          <Button
            onClick={() => setIsDeleteDialogOpen(false)}
            variant="outlined"
            color="inherit"
            sx={{ 
              borderRadius: 2,
              px: 3,
              borderColor: 'primary.main',
              color: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.light',
                color: 'primary.contrastText'
              }
            }}
          >
            Annuler
          </Button>
          <Button 
            onClick={handleDelete} 
            variant="contained"
            sx={{ 
              ml: 2,
              borderRadius: 2,
              px: 3,
              bgcolor: 'secondary.main',
              '&:hover': {
                bgcolor: 'secondary.dark'
              }
            }}
          >
            Supprimer 
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteDialog;